import { normalizeMenu } from "../utils/menu";
import request from "./request";

const menu = async () => {
  const { data } = await request({ url: "/v1/menu" });
  return normalizeMenu(data);
};

export default { menu };
